import React from "react";
import { useSelector, useDispatch } from 'react-redux';
import "./TermsAndCondition.scss";
import Layout from "../../components/layout/Layout";
import ContectInfo from '../../components/home/ContectInfo';
import { useQuery } from "react-query";
import { getlanguageAPI } from "../../services/api";
import { setLanguageIntial } from "../../store/language.slice";

function PrivacyPolicy() {
  const dispatch = useDispatch()
  const lnFromStore = useSelector(state=>state.language);
  const language = "en"

  let {isLoading}= useQuery(['policyTerms',language],getlanguageAPI.bind(null,language,"policyTerms"),{
          enabled:!lnFromStore[language],
          onSuccess: o => dispatch(setLanguageIntial({k:language,v:o}))
      });

  const { myAccount: account} = useSelector((state) => state.language?.activelang);
  const policyTerms = useSelector(state => state.language?.activelang?.policyTerms);
  const privacyPolicy = !!policyTerms?.privacyPolicy
  ? JSON.parse(policyTerms.privacyPolicy)
  : {}; 
  
  return (
    <Layout>
      {isLoading ? (
        <div className="full-window-loading payment-loading">
          <i className="pi pi-spin pi-spinner"></i>
          <h2 style={{color:"var(--text-color)"}}>{account.ACTN0037}</h2>
      </div>
      ) : (
      <section className="about-blocks-section tc-block">
        <div className="terms-and-conditions-section">
          <h1>{privacyPolicy.title}</h1>
          <div dangerouslySetInnerHTML={{ __html: privacyPolicy.description }}></div>
         </div>
      </section>
      )}

      {/*** ContactInfo Section ***/}
      <ContectInfo/>
      
    </Layout>
  );
}

export default PrivacyPolicy;
